module.exports = __webpack_public_path__ + "img/news-title.313f1f20.png";